const shortenText = (text: string, fieldSize?: 'default' | 'small' | 'extra-small' | 'large'): string => {
  const maxCharacters = fieldSize === 'large' ? 50 : fieldSize === 'default' ? 30 : fieldSize === 'small' ? 18 : 30;
  return text?.split?.('').length > maxCharacters && fieldSize ? text?.slice(0, maxCharacters)?.concat('...') : text;
};

export default shortenText;
